import { doc, setDoc } from "firebase/firestore";
import { FirestoreService } from "../Firebase/FirestoreService";
import { LtdConsentResponse } from "JS/Models/ConsentForm";
import { config } from "JS/Config";
import { appConstants } from "JS/Helpers/Constants";

export class ConsentStatusService extends FirestoreService {
    private memberId: string;

    constructor(memberId: string) {
        super();
        this.memberId = memberId;
    }

    private getDoc() {
        return doc(this.store, "ConsentForm", this.memberId);
    }

    public postConsentToFirestore() {
        if (this.isStoreActive()) {
            return setDoc(this.getDoc(), {
                consentStatus: true,
            });
        }
    }

    postLtdConsent = () =>
        this.ngCall("post", appConstants.ngEndpoints.postLtdConsent, {
            memberId: this.memberId,
            consentType: "LtdShareDataWithAmway",
            action: "Accept",
        });

    getLtdConsent = () =>
        this.ngCall<LtdConsentResponse>(
            "get",
            appConstants.ngEndpoints.getLtdConsent(config.user.memberId),
        );
}
